import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../service/auth-service';
import { passwordMatchValidator } from '../../validator/password-match';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-register',
  imports: [FormsModule, RouterLink, ReactiveFormsModule, MatSnackBarModule, FontAwesomeModule],
  templateUrl: './register.html',
  styleUrl: './register.scss'
})
export class Register implements OnInit {
  protected signUpForm: FormGroup;
  private authService = inject(AuthService)
  protected loading = false;
  private snackBar = inject(MatSnackBar)
  private analytics = inject(Analytics);
  private platformId = inject(PLATFORM_ID);
  hidePassword = true;
  hideConfirmPassword = true;

  faEye = faEye;
  faEyeSlash = faEyeSlash;

  constructor() {
    this.signUpForm = new FormGroup({
      fullName: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/)]),
      confirmPassword: new FormControl('', Validators.required)
    },
      {
        validators: passwordMatchValidator('password', 'confirmPassword')
      })
  }

  get password() {
    return this.signUpForm.get('password');
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      logEvent(this.analytics, 'register_page_view', { page_path: '/sign-up' });
    }
  }

  onSubmit() {
    this.loading = true
    const email = this.signUpForm.value.email;
    const password = this.signUpForm.value.password;
    const confirmPassword = this.signUpForm.value.confirmPassword;
    const fullName = this.signUpForm.value.fullName;

    this.authService.emailSignUp(email, password, fullName).subscribe({
      next: () => {
        this.loading = false
        this.snackBar.open('Registration successful!', 'Close', { duration: 5000 });
      },
      error: (err) => {
        this.loading = false
        this.snackBar.open("Registration Error!", 'Close', { duration: 5000 });
        console.log(err)
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  signUpWithGoogle() {
    this.authService.googleLogin().subscribe({
      next: () => {
        this.loading = false
        this.snackBar.open('Google sign-up successful!', 'Close', { duration: 5000 });
      },
      error: (err) => {
        this.loading = false
        this.snackBar.open("Registration Error!", 'Close', { duration: 5000 });
        console.log(err)
      },
      complete: () => {
        this.loading = false
      }
    });
  }
}
